import { createFileRoute } from "@tanstack/react-router";
import PasswordStrengthTesterPage from "@/pages/PasswordStrengthTesterPage";

export const Route = createFileRoute("/tools/password-strength-tester")({
  component: PasswordStrengthTesterPage,
});
